import React from 'react'
import { Route } from 'react-router';
import withAuthorization from 'utils/Firebase/Session/withAuthorization';

const AuthRoute = (props) => {
	return <Route {...props} />
}

const condition1 = authUser => authUser

export const VerifyRoute = withAuthorization(condition1)((props) => {
	return <Route {...props} />
})

const condition2 = authUser => !authUser

export const NoAuthRoute = withAuthorization(condition2, '/account')((props) => {
	return <Route {...props} />
})

const condition3 = authUser => (authUser && authUser.emailVerified)

export default withAuthorization(condition3, '/verify')(AuthRoute)
